<template>
  <div>
    <ticket v-for="ticket in tickets" :key="ticket.id"
      :event-name="event.name"
      :event-image="event.image"
      :event-location="event.location"
      :event-date="event.date"
      :event-note="event.note"
      :event-show-qrcode="event.show_qrcode"
      :ticket-type-name="ticket.name"
      :ticket-type-value="ticket.value"
      :ticket-number="ticket.number"
      :ticket-code="ticket.code">
    </ticket>
  </div>
</template>

<script>
import Ticket from './Ticket'

export default {
  name: 'Tickets',
  components: {
    'ticket': Ticket
  },
  data () {
    return {
      event: null,
      tickets: []
    }
  },
  created () {
    let event = this.$route.params.event
    let from = this.$route.params.from
    let to = this.$route.params.to

    let url = process.env.VUE_APP_URL_APP + '/b/events/' + event + '/tickets' +
      '?from_number=' + from + '&to_number=' + to

    this.$http.get(url).then(res => {
      this.event = res.body.data.event
      this.tickets = res.body.data.tickets
    }, err => {
      console.log(err)
    })
  }
}
</script>

<style>

</style>
